import React, {Fragment, Component} from 'react';
import {withTranslation} from 'react-i18next';
import {fetchUserStatus} from '../actions';
import {Guide} from '../components/Config.clashx';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import { Accordion, Message, Icon } from 'semantic-ui-react';

class Details extends Component {
  state = { activeIndex: -1 }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }

  render() {
    const { activeIndex } = this.state

    return (
      <Accordion styled style={{width:"100%"}}>
        <Accordion.Title
          active={activeIndex === 9}
          index={9}
          style={{color:"teal"}}
          onClick={this.handleClick}
        >
          <Icon name='dropdown' />
          如何切换 Rule/Global/Direct 模式
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 9}>
          <div class="markdown prose w-full break-words dark:prose-invert dark">
              <p>1. 点击 Proxies</p>
              <p>2. 选择 Rule/Direct</p>
              <p>通常你需要使用 RULE 模式才能正常访问网络</p>
              <p>使用 Direct 模式将不通过代理访问全部资源</p>
              <p>使用 Global 模式将全部流量发送到一个代理，而不是根据分流规则选择合适代理 </p>
              <p>我们建议您保持使用 RULE 模式</p>
          </div>
        </Accordion.Content>
        <Accordion.Title
          active={activeIndex === 0}
          index={0}
          style={{color:"teal"}}
          onClick={this.handleClick}
        >
          <Icon name='dropdown' />
          如何开启 TUN
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 0}>
          <div class="markdown prose w-full break-words dark:prose-invert dark">
              <p>TUN模式是通过在操作系统上安装一个虚拟网卡来实现的，它可以接管所有的网络流量，并将流量转发至Clash，然后由Clash发出请求。</p>
              <p>与普通的系统代理模式不同，虚拟网卡能够接管所有流量，而系统代理只能接管部分流量。TUN模式适用于以下场景：</p>
                <ol>
                    <li>一些软件无法设置系统代理，因此只能使用TUN模式接管流量，例如游戏和部分邮件客户端。</li>
                    <li>运行一些终端/命令行界面工具。</li>
                    <li>部分软件可能会检测用户是否在使用代理，并限制访问某些资源。</li>
                </ol>
                  <p>启用TUN模式的方法如下：</p>
                  <p>在 Windows 系统中：</p>
                  <ol>
                    <li>运行 Clash For Windows, 确保使用规则模式，并可以联网。</li>
                    <li>点击 General中的Service Mode右侧的Manage按钮，在弹出窗口中选择schtasks，安装服务模式。安装完成后，应用程序会自动重启，Service Mode右侧的地球图标变为绿色表示安装成功。</li>
                    <li>点击 General中的TUN Mode右侧的开关以启动TUN模式。</li>
                  </ol>
                  <p>在 Mac 系统中：</p>
                  <p>安装 <a href="https://install.appcenter.ms/users/clashx/apps/clashx-pro/distribution_groups/public">ClashX Pro</a>, 添加配置文件后，点击菜单的 Enhanced Mode 即可 </p>
                  <p>在 iOS/Android 系统中：</p>
                  <p>无需操作，全部代理应用都是使用TUN模式。</p>
                  <p>需要注意的是，除非在上述场景中，我们通常建议您在 Windows/Mac 使用系统代理模式，因为它更加方便且速度较快。</p>
          </div>
        </Accordion.Content>

        <Accordion.Title
          active={activeIndex === 1}
          index={1}
          style={{color:"teal"}}
          onClick={this.handleClick}
        >
          <Icon name='dropdown' />
          如何手动切换代理
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 1}>
          <p>Clash 配置中有两个主要的代理出口分别是Proxy和Video，它们默认是自动测速并选择最佳线路的，也可以手动选择具体的出口。</p>
          <p>Windows下手动选择代理的方法是:</p>
          <p>1. 点击 Proxies</p>
          <p>2. 选择 Rule</p>
          <p>3. 点击 Proxy 选择一个代理节点, 如选择GEO-US节点可以使用美国的IP。</p>
          <p>4. 点击 Video 选择一个代理节点</p>
          <p>5. 使用完后，点击Proxy和Video选择第一个节点恢复为自动最快节点。</p>
          <p>Mac 下手动选择代理的方法是:</p>
          <p>1. 点击 Clash 图标</p>
          <p>2. 点击 Proxy 选择一个代理节点</p>
          <p>3. 点击 Video 选择一个代理节点</p>
          <p>4. 使用完后，点击Proxy和Video选择第一个节点恢复为自动最快节点。</p>
          <p><a  rel="noopener noreferrer"  href="https://ip.skk.moe/">IP出口探测</a></p>
          <Message id="m4" style={{boxShadow:"none"}} icon>
            <Icon color='red' name="warning circle" />
            <Message.Content>
              <Message.Header>特别提示</Message.Header>
              1. 默认配置文件为最佳配置, 不建议改动。<br/>
              2. 选择GEO节点或Global会减速并不稳定, 只供临时使用。<br/>
              3. 请使用手动代理完成后(Global)，切换回自动测速模式(RULE)，否则速度会明显不稳定和变慢。<br/>
            </Message.Content>
          </Message>
          <b>提示: 默认配置为最稳定速度最好配置，改动会是速度不稳定和变慢。</b>

        </Accordion.Content>

        <Accordion.Title
          active={activeIndex === 2}
          index={2}
          style={{color:"teal"}}
          onClick={this.handleClick}
        >
          <Icon name='dropdown' />
          为什么不可以玩游戏？
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 2}>
          Clash 不适合大多数联机游戏。
        </Accordion.Content>

        <Accordion.Title
          active={activeIndex === 3}
          index={3}
          style={{color:"teal"}}
          onClick={this.handleClick}
        >
          <Icon name='dropdown' />
          如何设置Telegram, Line, UWP
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 3}>
      在Windows系统中，许多程序会跟随系统设置，通过设置系统代理使大部分程序使用代理。然而，仍有一些程序不会自动遵循系统代理，例如Telegram。在这种情况下，您需要手动调整这些程序的代理设置或使它们遵循系统配置。
      对于Telegram，点击盾牌图标并添加SOCKS5代理：IP地址为127.0.0.1，端口号为7890。
      对于UWP应用程序，在开启Clash系统代理的情况下，在“通用”界面点击“EnableLoopback.exe”，并为需要使用代理的UWP应用程序取消回环代理限制。
        </Accordion.Content>

        <Accordion.Title
          active={activeIndex === 4}
          index={4}
          style={{color:"teal"}}
          onClick={this.handleClick}
        >
          <Icon name='dropdown' />
          TUN模式和系统代理模式的区别是什么
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 4}>
          <p>系统代理是一种在计算机系统级别上设置的网络代理，它允许用户在访问互联网时将网络流量通过一个代理服务器进行转发。这样，用户可以绕过网络限制、提高安全性、隐藏真实IP地址或访问地理限制的资源。</p>
          <p>当您启用系统代理时，系统会将所有支持代理的应用程序的网络流量自动引导至指定的代理服务器。这意味着用户无需为每个应用程序单独配置代理设置，只需在操作系统级别进行一次设置即可。然而，需要注意的是，并非所有应用程序都支持系统代理设置，这也是为什么在某些场景下可能需要使用TUN模式等其他解决方案。</p>
        </Accordion.Content>

        <Accordion.Title
          active={activeIndex === 5}
          index={5}
          style={{color:"teal"}}
          onClick={this.handleClick}
        >
          <Icon name='dropdown' />
          什么是 Clash 的全局模式，规则模式，直连模式。
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 5}>
          <p>Clash 在其配置中有三种代理模式：全局模式、规则模式和直连模式。其中全局模式是将所有进入 Clash 网络流量都通过代理服务器转发的模式。</p>
          <p>当您将Clash的代理模式设置为全局模式时，全局模式将绕过所有规则，所有的网络请求都会通过代理服务器进行转发，无论这些请求是来自浏览器、应用程序还是操作系统本身。由于所有的网络流量都需要经过Clash转发，所以在使用全局模式时会对网络连接速度有较大的影响，同时也会增加代理服务器的负担。</p>
          <p>Clash 的规则模式是一种将网络流量通过“规则列表”控制代理转发的模式。在规则列表中，您可以定义网络请求的来源地址和目的地址，以及根据这些信息进行相应的代理规则判断。可以通过在规则列表中添加、编辑和删除规则来自定义代理规则的逻辑。</p>
      <p>
在规则模式下，Clash 会将所有的网络请求进行解析，并根据规则列表中的规则进行匹配和转发，以确保请求能够按照相应的代理规则进行流量转发。相对于全局模式，规则模式对网络连接速度的影响会更轻，也更加灵活，方便根据实际需要进行代理规则的定制。</p>
      <p>Clash 的直连模式是一种不通过代理服务器，直接访问目标服务器的网络流量转发方式。在直连模式下，没有代理服务器进行转发，请求直接发送到目标服务器，而不需要经过任何中间代理服务器的转发。</p>
<p>
相对于全局模式和规则模式，直连模式不需要经过Clash进行中间代理，因此在网络连接速度方面具有优势，特别是针对访问国内网络资源时，速度会更快。但同时，直连模式下也无法绕过网络屏蔽和限制，因此在需要访问被屏蔽或者限制的网络资源时，需要使用规则模式或者全局模式的代理方式来进行访问。</p>
      <p>我们推荐您一直使用规则模式</p>
        </Accordion.Content>

        <Accordion.Title
          active={activeIndex === 6}
          index={6}
          style={{color:"teal"}}
          onClick={this.handleClick}
        >
          <Icon name='dropdown' />
        为什么 Clash 提示订阅失败
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 6}>
          <p>订阅失败可能有多种原因，以下是一些建议您检查的常见问题：<br/>
1. DNS问题: DNS 故障会导致URL无法打开, 请更换您的DNS为119.29.29.29。
<br/>
2. 网络问题：我们在配置清单里提供了备用URL, 请更换订阅连接为 Alternative URL.
<br/>
3. 代理服务器问题：如果您当前Clash在运行全局或者规则代理模式，请切换到直连模式。
<br/>
4. 订阅链接问题：确保您提供的订阅链接是正确的。有时候，链接可能因为错误、过期或被撤销而失效。您可以尝试重新获取订阅链接。
<br/>
5. 订阅服务问题：订阅失败可能是由于订阅服务本身出现问题，例如服务器宕机、维护或更新。请尝试联系订阅服务提供商以获取进一步帮助。
<br/>
6. 应用程序问题：如果您使用的应用程序出现问题，可能会导致订阅失败。请确保您的应用程序已更新至最新版本。如有必要，尝试卸载并重新安装应用程序。
<br/>
7. 防火墙/安全软件限制：检查您的防火墙或安全软件设置，确保订阅服务和相关应用程序没有被阻止或限制。</p>
        </Accordion.Content>

        <Accordion.Title
          active={activeIndex === 7}
          index={7}
          style={{color:"teal"}}
          onClick={this.handleClick}
        >
          <Icon name='dropdown' />
            命令行里PING/GIT/CURL不工作
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 7}>
          <p>当您在系统代理模式下</p>
          <p>代理软件只是开启代理端口，一般只有浏览器会自动使用代理端口用于网络，其他的软件(TG/CMD/CLI/PING/GIT/SSH)都不会主动使用代理端口，请设置这些软件的网络为通过代理转发。<br/>
1. Clash for Windows 请点击General -> 点击“Port”右侧图标获得命令行命令, 并输入到CMD。<br/>
2. Clash X 点击 Copy Shell command 输入到CLI.<br/>
3. PING 不是TCP/UDP 协议，不适合代理模式，请选择TUN/增强模式.</p>
        </Accordion.Content>

        <Accordion.Title
          active={activeIndex === 8}
          index={8}
          style={{color:"teal"}}
          onClick={this.handleClick}
        >
          <Icon name='dropdown' />
            如何使用 Tik Tok
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 8}>
          <p>Tik Tok 会读取您的SIM卡，如果你需要使用请拔出SIM卡，或者WEB访问 https://www.tiktok.com/ </p>
        </Accordion.Content>

      </Accordion>
    )
  }
}

class Settings extends Component {

    constructor() {
        super(...arguments);
        this.props.onLoad()
    }

    componentDidMount(){
      window.scrollTo(0, 0);
    }

    render() {

        const status = this.props.status;
        const days   = status.days || 0;
        const domain = status.domain || '';

        const port = status.port || 0;
        const password = status.password || '';
        const dimmer = Object.keys(this.props.status).length === 0;
        const leftDays = parseInt(status.leftDays || 0, 10);

        const autoConfig = {
            password,
            port,
            prefix:domain,
            leftDays:leftDays,
            code:this.props.status.code,
            hashed:this.props.status.hashed,
            user_id:this.props.status.configureId,
            user_vip:this.props.status.vip
        };

        return <>
          <Guide t={this.props.t} data={autoConfig}/>
        </>
  }
}

const mapStateToProps = (state) => {
    const main = state.console.main;
    return {status: main.status};
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: () => {
            dispatch(fetchUserStatus());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Settings));
